import { Box, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseModalIcon from "../icons/CloseModalIcon";
import CustomButton from "../common/CustomButton";
import TransferPayment from "./TransferPayment";
import { RandomOrderId } from "../../Utils/helper";

const root = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%", // 90% width on extra small screens
    sm: "90%", // 80% width on small screens
    md: "40%", // 60% width on medium screens
    lg: "30%", // 40% width on large screens
  },
  height: {
    xs: "95%", // 90% width on extra small screens
    sm: "80%", // 80% width on small screens
  },
  bgcolor: "#15141B",
  color: "white",
  border: "none",
  boxShadow: 24,
  p: 4,
};

const iconContainer = {
  position: "absolute",
  cursor: "pointer",
  right: { xs: 30, sm: 16 },
  top: { xs: 30, sm: 16 },
  backgroundColor: "transparent",
};

const icon = {
  height: { xs: "12px" },
  width: { xs: "12px" },
};

const Banks = [
  {
    bank: "bidv",
    bank_name: "BIDV",
    account_no: "963012000515736",
    account_name: "ARTISM",
  },
  {
    bank: "bidv",
    bank_name: "BIDV",
    account_no: "963012000520967",
    account_name: "ARTISM",
  },
  {
    bank: "msb",
    bank_name: "MSB",
    account_no: "9686687660000390147",
    account_name: "ARTISM",
  },
];

export default function ModalDepositPaymentTransfer({
  setLoading = () => {},
  open = false,
  loading = true,
  amount = 0,
  handleDeposit = () => {},
  handleClose = () => {},
}) {
  const [selectedbank, setSelectedBank] = useState(
    Banks[Math.floor(Math.random() * Banks.length)]
  );
  const [orderId, setOrderId] = useState(
   RandomOrderId()
  );
  return (
    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={root} onClick={handleClose}>
          <Box sx={iconContainer}>
            <CloseModalIcon sx={icon} />
          </Box>
          <Box
            onClick={(event) => event.stopPropagation()}
            id="modal-modal-description"
            sx={{
              p: 5,
              overflowX: "auto",
              height: "90%",
              overFlowX: "auto",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari, and Edge
              },
            }}
          >
            <Box
              display="flex"
              justifyContent="center"
              flexDirection="column"
              alignItems="center"
            >
              <Box marginTop={4}>
                <Typography
                  variant="h5"
                  sx={{
                    textAlign: "center",
                  }}
                >
                  Payment
                </Typography>
              </Box>
              <Box
                width="100%"
                marginTop={2}
                marginBottom={4}
                display="flex"
                flexDirection="column"
                gap={1}
              >
                <TransferPayment
                  orderId={orderId}
                  selectedbank={selectedbank}
                  setLoading={setLoading}
                  loading={loading}
                  amount={amount}
                />
              </Box>
              <CustomButton
                disabled={loading}
                handleClick={() => {
                  handleDeposit();
                  handleClose();
                }}
              >
                Done
              </CustomButton>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
